import React from "react";
import ScrollHooks from "../ScrollHooks.js";
import AjaxHooks from "../AjaxHooks";
//import AjaxHooks from "../AjaxHooks";
// import { Menu as Menu1 } from "antd";
import "./menu2.css";
import { slide as Menu2 } from 'react-burger-menu';
import { Route, Routes, useNavigate } from "react-router-dom";
import {
  DashboardOutlined,
  HomeOutlined,
  UnorderedListOutlined,
  UserOutlined,
  PoweroffOutlined,
} from "@ant-design/icons/lib/icons";

// import Hw2 from "./components/Hw2";
import Hw2 from "../Hw2";
import Hw3 from "../Hw3";
// import Hw3 from "./components/Hw3";
import Hw4 from "../Hw4";
import Hw5 from "../Hw5";
import Header from "../Header";
// import Hw3ItemDetailContainer from "./components/Hw3ItemDetailContainer";
import Hw3ItemDetailContainer from "../Hw3/Hw3ItemDetailContainer";
// import Hw3ItemDetailContainer from "./components/Hw3/Hw3ItemDetailContainer";
import AddItem from "../AddItem";
import AddFile from "../AddFile";

const SideMenu2 = () => {
  const navigate = useNavigate();
  //console.log(window.screen.orientation);
  return (
    //<Menu theme="dark" mode="horizontal"
    <Menu2 width={ '10%' } >
    {/* <a id="home" className="menu-item" href="/">Home</a>
    <a id="about" className="menu-item" href="/Hw2">Hw2</a>
    <a id="contact" className="menu-item" href="/Hw3">Hw3</a>
    <a id="contact" className="menu-item" href="/Hw4">Hw4</a>
    <a id="contact" className="menu-item" href="/Hw5">Hw5</a> */}
    <a id="home" className="menu-item" onClick={()=>navigate("/")} >Home</a>
    <a id="Hw2" className="menu-item"  onClick={()=>navigate("/Hw2")} >Hw2</a>
    <a id="Hw3" className="menu-item"  onClick={()=>navigate("/Hw3")} >Hw3</a>
    <a id="Hw4" className="menu-item"  onClick={()=>navigate("/Hw4")} >Hw4</a>
    <a id="Hw5" className="menu-item" href="/Hw5">Hw5</a>
    <a id="AddItem" className="menu-item"  onClick={()=>navigate("/AddItem")} >AddItem</a>
    <a id="AddFile" className="menu-item"  onClick={()=>navigate("/AddFile")} >AddFile</a>
  </Menu2>
);
};

export default SideMenu2;
